module.exports = __webpack_public_path__ + "static/media/4.e2fc6cc3.jpg";